import axios from 'axios'
import app from '@/main'
import { Base64 } from 'js-base64'
import Vue from 'vue'
import { sdkUploader } from './upload-sdk'

export const ResHandle = (res) => {
  return {
    status: res.status,
    error_code: res.data.error_code || ''
  }
}

// 将CST时间转化为时间戳
export const formatCST = (time) => {
  return parseInt(+time / 1000)
}
// 将时间戳转换为日期
export const formatDate = (date, second = 10) => {
  if (second === 13) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return moment(new Date(date * 1000)).format('YYYY-MM-DD HH:mm:ss')
  }
}

/** 文件下载
 * content  返回结果   字符串
 * fileName 文件名
 */
export const funDownload = (content, filename) => {
  const eleLink = document.createElement('a')
  eleLink.download = filename
  eleLink.style.display = 'none'
  // 字符内容转变成blob地址
  const blob = new Blob([content])
  eleLink.href = URL.createObjectURL(blob)
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}

export const openLink = (url, newpage) => {
  newpage.location.href = url
}

// 删除对象空属性
export const deleteEmptyObj = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (!obj[key]) {
      delete obj[key]
    }
  })
}
// 判断操作系统
export const detectOS = () => {
  const sUserAgent = navigator.userAgent
  const isWin = navigator.platform === 'Win32' || navigator.platform === 'Windows'
  const isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel'
  if (isMac) return 'Mac'
  const isUnix = navigator.platform === 'X11' && !isWin && !isMac
  if (isUnix) return 'Unix'
  const isLinux = String(navigator.platform).indexOf('Linux') > -1
  if (isLinux) return 'Linux'
  if (isWin) {
    const isWin2K =
      sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1
    if (isWin2K) return 'Win2000'
    const isWinXP =
      sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1
    if (isWinXP) return 'WinXP'
    const isWin2003 =
      sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1
    if (isWin2003) return 'Win2003'
    const isWinVista =
      sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1
    if (isWinVista) return 'WinVista'
    const isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1
    if (isWin7) return 'Win7'
    const isWin8 =
      sUserAgent.indexOf('Windows NT 6.2') > -1 ||
      sUserAgent.indexOf('Windows NT 6.3') > -1 ||
      sUserAgent.indexOf('Windows NT 6.4') > -1 ||
      sUserAgent.indexOf('Windows NT 6.5') > -1 ||
      sUserAgent.indexOf('Windows 8') > -1
    if (isWin8) return 'Win8'
    const isWin10 =
      sUserAgent.indexOf('Windows NT 10.0') > -1 || sUserAgent.indexOf('Windows 10') > -1
    if (isWin10) return 'Win10'
  }
  return 'other'
}
export const getOS = () => {
  const agent = navigator.userAgent.toLocaleLowerCase()
  const isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel'
  if (isMac) return 'mac'
  if (agent.indexOf('win32') > -1 || agent.indexOf('wow32') > -1 || agent.indexOf('x64') < 0) {
    return 'win32'
  } else if (agent.indexOf('win64') > -1 || agent.indexOf('wow64') > -1) {
    return 'win64'
  } else if (agent.indexOf('windows nt 5.1') > -1 || agent.indexOf('windows xp') > -1) {
    return 'xp'
  }
  return ''
}

// 中间页跳转URL格式化
export const urlFormat = (url) => {
  const linkInfo = url.split('?')[1].split('&')
  // console.log(linkInfo)
  const data = {
    code: linkInfo[0].split('=')[1],
    pid: linkInfo[1].split('=')[1]
  }
  return data
}
export const cutString = (str, len) => {
  // length属性读出来的汉字长度为1
  if (!str) return
  if (str.length * 2 <= len) {
    return str
  }

  let strlen = 0

  let s = ''

  for (let i = 0; i < str.length; i++) {
    s = s + str.charAt(i)

    if (str.charCodeAt(i) > 128) {
      strlen = strlen + 2

      if (strlen >= len) {
        return s.substring(0, s.length - 1) + '...'
      }
    } else {
      strlen = strlen + 1

      if (strlen >= len) {
        return s.substring(0, s.length - 2) + '...'
      }
    }
  }

  return s
}

// 获取文件后缀
export const getFileSufix = (filename) => {
  const url = filename.split('?')[0]
  const arr = url.split('.')
  return arr[arr.length - 1]
}

/**
 * url 下载ulr
 * filename 文件名
 * downloadCb 下载进度条回调
 * errorCb 失败回调
 */
export const downloadFromQiniu = async (url, fileName, downloadCb, errorCb) => {
  const res = await axios({
    method: 'get',
    url: url,
    headers: {},
    responseType: 'arraybuffer',
    withCredentials: false,
    timeout: 0,
    onDownloadProgress(progressEvent) {
      if (downloadCb && progressEvent.lengthComputable) {
        downloadCb(progressEvent)
      }
    }
  }).catch((e) => {
    if (errorCb) {
      errorCb()
    }
  })
  if (res.status === 200) {
    const sufix = getFileSufix(url)
    funDownload(res.data, fileName.includes('.') ? fileName : fileName + '.' + sufix)
  }
}

export const workScoreFilter = (value) => {
  if (value >= 0 && value < 10) {
    return 0
  } else if (value >= 10 && value < 20) {
    return 0.5
  } else if (value >= 20 && value < 30) {
    return 1
  } else if (value >= 30 && value < 40) {
    return 1.5
  } else if (value >= 40 && value < 50) {
    return 2
  } else if (value >= 50 && value < 60) {
    return 2.5
  } else if (value >= 60 && value < 70) {
    return 3
  } else if (value >= 70 && value < 80) {
    return 3.5
  } else if (value >= 80 && value < 90) {
    return 4
  } else if (value >= 90 && value < 100) {
    return 4.5
  } else if (value === 100) {
    return 5
  }
}

export const formatMenu = (value, spliceValue) => {
  const index = value.indexOf(spliceValue)
  if (index > -1) {
    value.splice(index, 1)
  }
  return value
}

/**
 *
 * @param {*} key 键
 * @param {*} value 值
 * @param {*} exp 保存时间，单位为（天）
 * @param {*} exp_is_absolute //天数是否为相对时间，例如+1天只会到第二天0点既消失
 */
export function create_cookie(key, value, exp, exp_is_absolute = false) {
  let date = new Date()
  if (exp_is_absolute) {
    date.setDate(date.getDate() + exp)
    date = new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`)
  } else {
    date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000)
  }
  const expires = '; expires=' + date.toGMTString()
  document.cookie = key + '=' + value + expires + '; path=/'
}

/**
 * Returns contents of cookie
 * @param  key  The key or identifier for the store
 */

export function read_cookie(key) {
  const nameEQ = key + '='
  const ca = document.cookie.split(';')
  for (let i = 0, max = ca.length; i < max; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length)
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length)
    }
  }
  return null
}

export const pathBasename = (fileUrl) => {
  const url = fileUrl.split('?')[0]
  const arr = url.split('/')
  return arr[arr.length - 1]
}

export const normalFilename = (fileUrl, fullback) => {
  if (/^new_upload\//.test(fileUrl)) {
    return pathBasename(fileUrl)
  }
  return fullback
}

export function colorRgb(sHex, alpha = 1) {
  // 十六进制颜色值的正则表达式
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  /* 16进制颜色转为RGB格式 */
  let sColor = sHex.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    //  处理六位的颜色值
    const sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    // return sColorChange.join(',')
    // 或
    return sColorChange.join(',')
  } else {
    return sColor
  }
}

/**
 * 遍历菜单
 * @param {Object} obj - 本地匹配的对象
 * @param {Array} menus - 后台返回的菜单
 */
export const mapMenus = (obj, menus) => {
  let data
  for (const [key, val] of Object.entries(obj)) {
    if (key.indexOf(menus.custom_menu_id) > -1) data = val
  }
  return data
}

/**
 * 课程中心处理模版名称
 * @param {String} fileUrl - 模版名称
 */
export const formatFileName = (fileUrl = '') => {
  if (/.*\.html$/i.test(fileUrl)) {
    return fileUrl && fileUrl.match(/.*?\/([^/]*)\/[^/]*?\.html$/)[1]
  } else {
    const reg = /[^/]*?\.(pdf|doc|docx|ppt|pptx|mp4|bcm|sb3|sb2|png|jpg|jpeg|gif|py|hex)$/i
    const m = fileUrl.match(reg)
    return Array.isArray(m) ? m[0] : fileUrl
  }
}

/**
 * @param {*} fileUrl 处理附件文件名
 */

export const formatAttachmentName = (fileUrl) => {
  return fileUrl.substring(fileUrl.lastIndexOf('/') + 1)
}

/**
 * 格式化文件大小
 *
 * @export
 * @param {number} size - 大小
 * @returns
 */
export function formatSize(size) {
  const i = Math.floor(Math.log(size) / Math.log(1024))
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
}

/**
 * @param {*} 检测浏览器是否缩放
 */
export const detectionBrowser = async () => {
  const ua = navigator.userAgent.toLowerCase()
  if (!/chrome\/\d+/.test(ua)) return
  const ratio = await detectZoom()
  if (ratio !== 100) {
    app.$notify({
      type: 'warning',
      message: `您的浏览器页面可能处于${
        ratio > 100 ? '放大' : '缩小'
      }（${ratio}%）状态，您可以按键盘“ctrl+数字0”组合键恢复初始状态！`,
      duration: 5000
    })
  }
}
export const detectZoom = () => {
  let ratio = 0
  ratio = window.outerWidth / window.innerWidth
  if (ratio) ratio = Math.round(ratio * 100)
  // 浏览器最大化时诡异的outerWidth和innerWidth不相等
  if (ratio === 99 || ratio === 101) ratio = 100
  return ratio
}

// 小数转百分比
export const toPercent = (point) => {
  let str = Number(point * 100).toFixed(1)
  str += '%'
  return str
}

/**
 * 批量导出班级成长档案
 * @param {*} urlArray 图片地址
 * @param {*} class_id 班级id
 */
export const downloadZip = (urlArray, class_id) => {
  return new Promise(async (resolve, reject) => {
    let str = ''
    urlArray.forEach((row) => {
      if (row.profile_url) {
        str += `/url/${Base64.encodeURI(row.profile_url)}/alias/${Base64.encodeURI(
          formatFileName(row.profile_url)
        )}\n`
      }
    })
    const file = new File([str], `${class_id}.txt`, { type: 'text/plain;charset=utf-8' })
    const { url } = await sdkUploader(file, {
      filename: `sdk_upload/${Date.now()}/${file.name.replace(/\s+/g, '').trim()}`
    })
    // 将所有学生的成长档案链接写入txt文件，通知后端打包压缩
    const { status, data } = await window.API.post(`/edu/zone/growth/profile/download`, {
      file_key: url.match(/codemao.cn\/(.*)/)[1]
    })
    if (status === 200) resolve(data)
  })
}

/**
 * 匹配特殊字符
 */
export const SpecialCharacters = /^[\u2E80-\uFE4Fa-zA-Z0-9]+$/

export const truncateString = (string = '', length) => {
  return length ? (string.length < length ? string : `${string.slice(0, length)}...`) : string
}

/**
 * 文件大小带单位
 * @method sizeFilter
 * @param {Number} size 文件大小
 * @param {Number} [pointLength=2] 精确到的小数点数。
 * @param {Array} [units=[ 'B', 'K', 'M', 'G', 'TB' ]] 单位数组。从字节，到千字节，一直往上指定。如果单位数组里面只指定了到了K(千字节)，同时文件大小大于M, 此方法的输出将还是显示成多少K.
 */
export const sizeFilter = (size, pointLength, units) => {
  let unit
  units = units || ['B', 'K', 'M', 'G', 'T']
  while ((unit = units.shift()) && size > 1024 && units.length) {
    size = size / 1024
  }
  return (unit === 'B' ? size : size.toFixed(pointLength === 0 ? 0 : pointLength || 2)) + unit
}

/**
 * 计算开始时间
 * @param {*} startTime 开始时间
 * @returns xx:xx:xx
 */
export function timekeeping(startTime) {
  function p(n) {
    return n < 10 ? '0' + n : n
  }
  return function () {
    const now = new Date()
    const countDown = (now.getTime() - startTime.getTime()) / 1000

    // const oDay = parseInt(countDown / (24 * 60 * 60))

    const oHours = parseInt((countDown / (60 * 60)) % 24)

    const oMinutes = parseInt((countDown / 60) % 60)

    const oSeconds = parseInt(countDown % 60)

    return p(oHours) + ':' + p(oMinutes) + ':' + p(oSeconds)
  }
}

export const eventbus = new Vue()
